module.exports = __webpack_public_path__ + "ce4f2a0effd51cbf820258e4e27a5168.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review_1.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review_1.jpg
// module chunks = 40